export const GET_ACCT_HISTORY_ATTEMPT = 'GET_ACCT_HISTORY_ATTEMPT';
export const GET_ACCT_HISTORY_SUCCESS = 'GET_ACCT_HISTORY_SUCCESS';
export const GET_ACCT_HISTORY_FAILURE = 'GET_ACCT_HISTORY_FAILURE';
export const CLEAR_STATE = 'CLEAR_STATE';
